import React, { useState, useEffect } from 'react';
import { faBalanceScale, faBoxes, faCalendarAlt, faFileAlt, faFilter, faIndustry, faSearch, faStoreAltSlash, faTruck, faTruckLoading, faUser, faUserClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';

//Components
import InfoCard from '../../../components/InfoCard/InfoCard';
import TextField from '../../../components/TextField/TextField';
import ModalCustomized from '../../../components/Modal/Modal';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';

//Api
import dashboard_api from '../../../api/dashboard_api';
import autoInfracao_api from '../../../api/autoInfracao_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from '../../../context/auth';
import { useDashboard } from 'context/DashboardContext';
import AutosInfracoes from './AutosInfracoes';

//Estado inicial dos filtros
function initialStateFiltros() {
    const dataInicial = new Date();
    const dataFinal = new Date();
    dataInicial.setDate(dataFinal.getDate() - 30);

    return {
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(dataFinal).format("YYYY-MM-DD"),
        prefeituraId: 0,
    }
}
export default function DashBoardTransportador() {
    const { dadosDashboardProvider, setDadosDashboardProvider } = useDashboard();

    const { setupVariavel, setLoading } = useAuth();

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Estado que controla a exibição dos filtros
    const [openFiltros, setOpenFiltros] = useState(false);

    //Função que faz a troca da visualização dos filtros
    const toggleFiltros = () => setOpenFiltros(!openFiltros);

    //Estado de controle de exibição do modal do top de geradores
    const [openModal, setOpenModal] = useState(false);

    //Função d etroca do estado de exibição do modal
    const toggleModal = () => setOpenModal(!openModal);

    //variavel de navegação
    const navigate = useNavigate();

    //Estado que controlar a exibição da lista dos autos das infrações
    const [visibleAutosInfracoes, setVisibleAutosInfracoes] = useState(false);

    //Estado que guarda os dados da dashboard
    const [dadosDashboard, setDadosDashboard] = useState(null);

    //Cabeçalhos da tabela de top 10 geradores
    const headersTopGeradores = [
        { value: "Posição", objectValue: "posicao" },
        { value: "Descrição", objectValue: "gerador" },
        { value: "Coletas realizadas", objectValue: "quantidade" }
    ]

    //OnChange para os campos de filtros de datas
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    const carregaDadosDashboard = (buttonFiltro = false) => {
        if (!buttonFiltro && !!dadosDashboardProvider && !!dadosDashboardProvider?.recarregarViaContext) {
            setDadosDashboard(dadosDashboardProvider);
            return;
        }

        setLoading(true);
        const _filtros = { ...filtros };
        _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
        _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
        dashboard_api.GetDashboard(_filtros).then(response => {
            response.data.top10Geradores = response.data.top10Geradores.map((value, index) => {
                value.posicao = index + 1;
                return value;
            })
            setDadosDashboard(response.data);
            setDadosDashboardProvider({ ...response.data, recarregarViaContext: true });
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Carrega os dados da tela assim que inicializada
    useEffect(() => {
        carregaDadosDashboard();
    }, []);


    if (visibleAutosInfracoes) {
        return <AutosInfracoes
            btnVoltar={() => {
                carregaDadosDashboard(true);
                setVisibleAutosInfracoes(false);
            }}
        />
    }

    return (
        <div className='dashboard mt-3 mx-3'>
            <ModalCustomized title={"Top 10 geradores"} isOpen={openModal} toggle={toggleModal} btnClose>
                <TabelaListagem headers={headersTopGeradores} items={dadosDashboard ? dadosDashboard.top10Geradores : []} options={{ print: false, search: true, pagination: true }} />
            </ModalCustomized>
            <div className='d-flex align-items-center justify-content-between'>
                <h4>Informações Estatísticas</h4>
                <Button color="primary text-light" onClick={toggleFiltros} ><FontAwesomeIcon icon={faFilter} /> Filtrar</Button>
            </div>

            <div className={`filtros ${openFiltros ? "" : "close"}`}>
                <Row>
                    <Col md="12" lg="5">
                        <TextField label={"Inicio"} type="date" value={filtros.dataInicial} name={"dataInicial"} onChange={onChangeFiltros} />
                    </Col>
                    <Col md="12" lg="5">
                        <TextField label={"Fim"} type="date" value={filtros.dataFinal} name={"dataFinal"} onChange={onChangeFiltros} />
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg='12'>
                        <Button color='info text-light' onClick={() => carregaDadosDashboard()}><FontAwesomeIcon icon={faSearch} /> Filtrar</Button>
                    </Col>
                </Row>
            </div>

            <div className="mt-2">
                <h4>Dados das coletas</h4>
                <div className='mb-4'>
                    <Row>
                        <Col md="12" lg="4">
                            <InfoCard icon={faTruckLoading} title={"Coletas realizadas"} specialSubTitle={dadosDashboard?.coletasRealizadas} />
                        </Col>
                        <Col md="12" lg="4">
                            <InfoCard icon={faBoxes} title={"Volume estimado"} specialSubTitle={dadosDashboard?.volumeEstimado} />
                        </Col>
                        <Col md="12" lg="4">
                            <InfoCard icon={faCalendarAlt} title={"Média diária"} specialSubTitle={dadosDashboard?.mediaDiaria} />
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col md="12" lg="4">
                            <InfoCard icon={faUser} title={"Média por motorista"} specialSubTitle={dadosDashboard?.mediaMotorista} />
                        </Col>
                        <Col md="12" lg="4">
                            <InfoCard link icon={faStoreAltSlash} onClick={() => navigate("../coletas/coletas-recusadas", { state: { btnVoltar: true, filtros: { dataInicial: filtros.dataInicial + " 00:00:00", dataFinal: filtros.dataFinal + " 23:59:59" } } })} title={"Coletas recusadas"} specialSubTitle={dadosDashboard?.coletasRecusadas} />
                        </Col>
                    </Row>
                </div>

                <h4>Dados dos Contratos</h4>
                <Row className='mb-4'>
                    <Col md="12" lg="4">
                        <InfoCard
                            link
                            icon={faIndustry}
                            onClick={() => navigate("../geradores/contratos", { state: { btnVoltar: true, filtros: { dataInicial: filtros.dataInicial + " 00:00:00", dataFinal: filtros.dataFinal + " 23:59:59" }, option: "contratos a vencer" } })}
                            title={"Contratos a vencer"}
                            specialSubTitle={dadosDashboard?.totalContratosAVencer > 0 ? dadosDashboard?.totalContratosAVencer : "0"}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <InfoCard
                            link
                            icon={faIndustry}
                            onClick={() => navigate("../geradores/contratos", { state: { btnVoltar: true, filtros: { dataInicial: filtros.dataInicial + " 00:00:00", dataFinal: filtros.dataFinal + " 23:59:59" }, option: "contratos vencidos" } })}
                            title={"Contratos vencidos"}
                            specialSubTitle={dadosDashboard?.totalContratosVencidos > 0 ? dadosDashboard?.totalContratosVencidos : "0"}
                        />
                    </Col>
                </Row>

                <h4>Top 10</h4>
                <Row className='mb-4'>
                    <Col md="12" lg="4">
                        <InfoCard
                            onClick={toggleModal}
                            link
                            icon={faTruck}
                            title={"Top 10 geradores"}
                            subTitle={"clique aqui e veja mais"}
                        />
                    </Col>
                </Row>

                <h4>Autos de infração</h4>
                <Row className='mb-4'>
                    <Col md="12" lg="4">
                        <InfoCard
                            link
                            icon={faBalanceScale}
                            onClick={() => {
                                if (dadosDashboard?.quantidadeAutoInfracoes == 0)
                                    return showMessage("Aviso", "Você não tem nenhum auto de infração.", "warning", null);

                                setVisibleAutosInfracoes(true);
                            }}
                            title={"Quantidade de autos de infração"}
                            specialSubTitle={dadosDashboard?.quantidadeAutoInfracoes > 0 ? dadosDashboard?.quantidadeAutoInfracoes : "0"}
                        />
                    </Col>
                </Row>

                {(setupVariavel?.integracaoCadastros || setupVariavel?.informarTransportadorAprovacaoCadastro) &&
                    <>
                        <h4>Contratos Pendentes</h4>
                        <Row className='mb-4'>
                            <Col md="12" lg="4">
                                <InfoCard
                                    onClick={() => navigate("../geradores/contratos", { state: { option: "Contrato Pendente" } })}
                                    link
                                    icon={faUserClock}
                                    title={"Geradores com contratos pendentes"}
                                    specialSubTitle={dadosDashboard?.contratosPendentes}
                                />
                            </Col>
                        </Row>
                    </>
                }

                {setupVariavel?.analisePGRS == true &&
                    !!dadosDashboard?.totalAguardandoAtivacaoContratoPGRS &&
                    <>
                        <h4>Contrato via PGRS</h4>
                        <Row className='mb-4'>
                            <Col md="12" lg="4">
                                <InfoCard
                                    onClick={() => navigate("../geradores/aguardandoAtivacaoContratoPGRS")}
                                    link
                                    icon={faFileAlt}
                                    title={"Geradores aguardando ativação de contrato via PGRS"}
                                    specialSubTitle={dadosDashboard?.totalAguardandoAtivacaoContratoPGRS}
                                />
                            </Col>
                        </Row>
                    </>}
            </div>
        </div>
    )
}